export default "__VITE_ASSET__f0054b15__"